'use strict';

const areEmbeddedValues = require('./areEmbeddedValues');
const inspectable = require('../rlink-inspectable-error');

module.exports = function areRelatedEmbeddedValues (values) {
  if (Array.isArray(values)
      && Array.isArray(values[0])) {
    const nestedAreEmbeddedValues = areEmbeddedValues(values[0]);
    const restAreEmbeddedValues = areEmbeddedValues(values.slice(1));

    if (!!nestedAreEmbeddedValues !== !!restAreEmbeddedValues) {
      throw inspectable`Inconsistent ${{ values }} - at least one value is an EmbeddedValue but some are not!`;
    }

    return nestedAreEmbeddedValues && restAreEmbeddedValues;
  }

  return false;
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/areRelatedEmbeddedValues.js